<button
    mat-flat-button
    (click)="
        navigateToClassroom(classSessionId, classId, isZoomCreated);
        $event.stopPropagation()
    "
>
    {{ text | transloco }}
</button>
